import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/app/_app/org/$orgId/app/$appId/messages/$messageId")({
	component: MessageDetailPage,
});

function MessageDetailPage() {
	const { messageId } = Route.useParams();

	return (
		<div className="p-4 sm:p-6 lg:p-8 max-w-3xl mx-auto">
			<header className="mb-6">
				<p className="font-mono text-xs uppercase tracking-wide text-base-content/55">message</p>
				<h1 className="mt-1 font-mono text-lg sm:text-xl text-base-content break-all">
					{messageId}
				</h1>
			</header>
			<div className="rounded-box border border-base-300 bg-base-100 p-5">
				<p className="text-sm text-base-content/55">Message details will be loaded from the API.</p>
			</div>
		</div>
	);
}
